export const DELIVERY_METHOD_ADDRESS = 1
export const DELIVERY_METHOD_SELF = 2
